enum Role {
    admin = "admin",
    user = "user"
}

namespace Role {
    export function getDisplayName(role: keyof typeof Role) {
        switch (role) {
            case Role.admin:
                return '관리자';
            case Role.user:
                return '사용자';
            default:
                return '';
        }
    }
}

export default Role;